import React, { useState } from "react";
import { QUESTIONS } from "../data/quiz";
import { useLang } from "../i18n/LanguageContext";

export default function Quiz({ onComplete, onExit }) {
  const { lang, t } = useLang();
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState(Array(QUESTIONS.length).fill(null));
  const q = QUESTIONS[step];
  const isLast = step === QUESTIONS.length - 1;

  const select = (opt) => {
    const next = [...answers];
    next[step] = opt;
    setAnswers(next);
    setTimeout(() => {
      if (isLast) {
        onComplete(next);
      } else {
        setStep(step + 1);
      }
    }, 220);
  };

  const goBack = () => {
    if (step === 0) {
      onExit();
    } else {
      setStep(step - 1);
    }
  };

  const progress = ((step + 1) / QUESTIONS.length) * 100;
  const eyebrow = lang === "en" ? q.eyebrow_en : q.eyebrow;
  const prompt = lang === "en" ? q.prompt_en : q.prompt;

  return (
    <div className="relative min-h-screen w-full flex flex-col" data-testid="quiz-page">
      <div className="ac-ambient" />

      <header className="relative z-10 pt-6 sm:pt-8 px-5 sm:px-8 max-w-xl w-full mx-auto">
        <div className="flex items-center justify-between mb-4">
          <button
            className="text-[11px] font-mono uppercase tracking-[0.24em] text-[color:var(--ac-ink-soft)] hover:text-[color:var(--ac-ink)] transition"
            onClick={goBack}
            data-testid="quiz-back-button"
            aria-label={t.quizBack}
          >
            {t.quizBack}
          </button>
          <span className="text-[11px] font-mono uppercase tracking-[0.24em] text-[color:var(--ac-ink-muted)]" data-testid="quiz-step-indicator">
            {t.quizStepLabel(step + 1, QUESTIONS.length)}
          </span>
        </div>
        <div className="ac-progress" data-testid="quiz-progress">
          <span style={{ width: `${progress}%` }} />
        </div>
      </header>

      <main className="relative z-10 flex-1 flex flex-col px-5 sm:px-8 pt-10 pb-10 max-w-xl w-full mx-auto">
        <div key={`${q.id}-${lang}`} className="flex-1 flex flex-col">
          <p className="ac-eyebrow ac-in mb-4" data-testid="quiz-eyebrow">
            {eyebrow}
          </p>
          <h2
            className="ac-display text-[32px] sm:text-4xl mb-8 ac-in ac-in-delay-1"
            data-testid="quiz-question"
          >
            {prompt}
          </h2>

          <div className="flex flex-col gap-3 sm:gap-4">
            {q.options.map((opt, i) => (
              <button
                key={i}
                className="ac-option ac-in"
                style={{ animationDelay: `${140 + i * 60}ms` }}
                onClick={() => select(opt)}
                data-testid={`quiz-option-${i}`}
              >
                <span className="ac-bullet" />
                <span>{lang === "en" ? opt.label_en : opt.label}</span>
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
